import { Sprout } from "lucide-react";

// Text logo for "Pousse" — modern rounded display font + small green sprout,
// consistent with the growing tree. Descriptor always shown next to the name.
export const Logo = ({ size = "sm", className = "" }) => {
  const box = size === "lg" ? "h-11 w-11 rounded-2xl" : "h-9 w-9 rounded-xl";
  const icon = size === "lg" ? "h-6 w-6" : "h-5 w-5";
  const name = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="app-logo">
      <div className={`${box} bg-lime-400 flex items-center justify-center shrink-0`}>
        <Sprout className={`${icon} text-[#0A0F0D]`} />
      </div>
      <div className="leading-tight">
        <span className={`font-display ${name} font-black tracking-tight block`}>Pousse</span>
        <span className="block text-[11px] text-white/50 font-medium">Ton coach sport &amp; nutrition</span>
      </div>
    </div>
  );
};
